import type { CSSProperties } from "react";

// Inline-style replacements for the prototype's data-stagger / --d attributes. Inline styles are
// part of the prerendered HTML, so SSG and client markup match.

/** Stagger index for the reveal transition-delay (capped at 8, like the prototype). */
export const stagger = (i: number): CSSProperties => ({ "--i": Math.min(i, 8) }) as CSSProperties;

/** Extra reveal delay in ms. */
export const delay = (ms: number): CSSProperties => ({ "--d": `${ms}ms` }) as CSSProperties;
